import { useWindowDimensions } from './useWindowDimensions';

export const useIsMobile = (threshold = 1024): boolean => {
  const { width } = useWindowDimensions({ memoThreshold: 100 });

  return width < threshold;
};
